// extracted by mini-css-extract-plugin
export default {"color":"#4036ed"};